import { addNewElement, adjustLogoOriginSizeByLimitation } from '../../canvas/logics';
import { applyArt, saveImageOriginColors, unSelectAllImage } from '../../canvas/actions';
import {
  autoColorizeForUploadLogo,
  checkAndSharpen,
  confirmAutoColorize,
  doActionsAfterProgressComplete,
  hideCover,
} from '../../uploadimage/components/UploadButton/logics';
import { elementStatus, removeWhiteMode, undoRedoType } from '../../utils/constants';
import { flipTypes, nextgenScreenMode } from '../constants';
import { getCanvasDraggingArea, getCurrentCanvasData, getSelectedImage } from '../../canvas/selectors';
import {
  getCurrentHotStampedCheck,
  getCurrentImprintAreaKey,
  getCurrentImprintProcessType,
  getLogoEditingStatus,
  getStudioItemType,
  getVendorId,
} from '../../main/selectors';
import {
  getCurrentImprintFormat,
  getHasOneImprintColorOnly,
  getImprintColors,
  getImprintOptionType,
} from '../../imprintarea/selectors';
import { getImageByGuid, getIsMultipleArtMultipleColor } from '../canvas/selector';
import { getSavedArtListApi, uploadSavedArt } from './apis';
import { getScreenMode, offsetNewRecentArtOrText, switchElementApplyingStatus } from '../../nextgen/logics';
import {
  recentArtsInitAsync,
  setUserImageOriginalSizeAsync,
  userImageColorizeForNonDigitalAsync,
} from '../../userimage/logics';

import { changeArtColor } from '../../canvas/actions';
import { changeColor } from '../../text/logics';
import { changeLogoColor } from '../../uploadimage/logics';
import { changeNextgenUiStatus } from '../actions';
import { getAllColorsInUse } from '../../userimage/selectors';
import { getImageDimension } from '../../utils/scene7url';
import { getStoreData } from '../../uploadimage/selectors';
import { nextGenFlyoutPanelEnum } from '../constants';
import { pushToUndoList } from '../../canvas/components/UndoRedo/logic';
import { savedArtsListInit } from '../../userimage/actions';
import { studioItemType } from '../../main/constants';
import { studioItemType as studioItemTypeEnum } from '../../main/constants';
import { updateFullPreview } from '../../preview/logics';
import { userImageType } from '../../utils/constants';
import { v4 as uuidv4 } from 'uuid';

export const applySavedArt =
  ({ art }) =>
  (dispatch, getState) => {
    const state = getState();
    const guid = uuidv4();
    const vendorId = getVendorId(state);
    const currentImprintFormat = getCurrentImprintFormat(state);

    dispatch(switchElementApplyingStatus({ element: art, type: art.type, isApplying: true }));

    if (getScreenMode() === nextgenScreenMode.small) {
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
    }

    uploadSavedArt(vendorId, art.description, guid).then((response) => {
      const {
        canvasKey,
        canvasData,
        selectedLogo,
        vendorId,
        itemId,
        isHotStamped,
        draggingArea,
        hasOneImprintColorOnly,
        studioItemType,
        logoEditingStatus,
        imprintColorList,
        maxColorCount,
        textColor,
        processType,
        defaultImprintColor,
        itemUseScene7Template,
        imprintOptionType,
        imprintAreaCode,
        allColorsInUse,
      } = getStoreData(state);
      const progressCheckParams = {
        dispatch,
        canvasKey,
        draggingArea,
        vendorId,
        studioItemType,
        itemId,
        hasOneImprintColorOnly,
        isHotStamped,
        selectedLogo,
        canvasData,
        imprintColorList,
        maxColorCount,
        textColor,
        logoEditingStatus,
        lowDpiLogoGuid: logoEditingStatus.lowDpiData?.lowDpiLogoGuid,
        processType,
        defaultImprintColor,
        itemUseScene7Template,
        isNextgenUi: true,
        currentImprintFormat,
        imprintOptionType,
        directToCanvas: true,
        imprintAreaCode,
        allColorsInUse,
      };
      const newImageData = response.data;

      doActionsAfterProgressComplete(progressCheckParams, newImageData);
      dispatch(switchElementApplyingStatus({ element: art, type: art.type, isApplying: false }));
    });
  };
export const applySharedArt =
  ({ art }) =>
  (dispatch, getState) => {
    const state = getState();
    const draggingArea = getCanvasDraggingArea(state);
    const studioItemType = getStudioItemType(state);
    const imprintAreaKey = getCurrentImprintAreaKey(state);
    const canvasData = getCurrentCanvasData(state);

    const applyFinishCallback = () => {
      dispatch(pushToUndoList(undoRedoType.SelectSharedArt));
      dispatch(switchElementApplyingStatus({ element: art, type: art.type, isApplying: false }));
      dispatch(updateFullPreview());
      dispatch(
        changeNextgenUiStatus({
          flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.EditImagePanel },
        })
      );
    };
    const getImageDimensionCallback = (dimension) => {
      const newArt = {
        data: { ...art },
        ui: {
          guid: uuidv4(),
          status: elementStatus.SingleSelected,
          design: false,
        },
      };

      dispatch(setUserImageOriginalSizeAsync(newArt.data, dimension));

      newArt.data.x = draggingArea.x;
      newArt.data.y = draggingArea.y;
      newArt.data.direction = 0;
      newArt.data.originalWidth = dimension.width;
      newArt.data.originalHeight = dimension.height;
      newArt.data.width = dimension.width;
      newArt.data.height = dimension.height;

      newArt.ui.outlineRect = {
        x: newArt.data.x,
        y: newArt.data.y,
        width: newArt.data.width,
        height: newArt.data.height,
      };

      adjustLogoOriginSizeByLimitation(newArt.data, studioItemType, draggingArea);

      newArt.data.x = Math.round((draggingArea.width - newArt.data.width) / 2 + draggingArea.x);
      newArt.data.y = Math.round((draggingArea.height - newArt.data.height) / 2 + draggingArea.y);

      offsetNewRecentArtOrText(newArt, canvasData.imageList);

      dispatch(recentArtsInitAsync({ userImage: newArt.data, formatkey: imprintAreaKey }));
      dispatch(
        addNewElement(
          (elementId, layerIndex) =>
            dispatch(
              applyArt({
                canvasKey: imprintAreaKey,
                newArt,
                elementId,
                layerIndex,
              })
            ),
          newArt.data
        )
      );

      if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
        dispatch(
          userImageColorizeForNonDigitalAsync({
            formatkey: imprintAreaKey,
            userImage: newArt.data,
            watchGuid: newArt.ui.guid,
            callback: applyFinishCallback,
          })
        );
      } else {
        applyFinishCallback();
      }
    };
    dispatch(switchElementApplyingStatus({ element: art, type: art.type, isApplying: true }));
    getImageDimension(studioItemType, art.scene7FileName, getImageDimensionCallback);

    if (getScreenMode() === nextgenScreenMode.small) {
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
    }
  };

export const applyUploadLogo =
  ({ logo }) =>
  (dispatch, getState) => {
    const state = getState();
    const canvasKey = getCurrentImprintAreaKey(state);
    const draggingArea = getCanvasDraggingArea(state);
    const studioItemType = getStudioItemType(state);
    const canvasData = getCurrentCanvasData(state);

    let newLogo = {
      data: Object.assign({}, logo),
      ui: {
        guid: uuidv4(),
        status: elementStatus.SingleSelected,
      },
    };

    let hasLatestLogo = false;

    if (logo.finalUpdated) {
      const latestLogo = getImageByGuid(state, logo.finalUpdated.ui.guid);
      // use latest image from store if exists, avoid duplicate colorize for the same recent
      if (latestLogo) {
        newLogo = {
          data: Object.assign({}, latestLogo.data),
          ui: Object.assign({}, latestLogo.ui, {
            guid: uuidv4(),
          }),
        };
        hasLatestLogo = true;
      }
    }

    delete newLogo.data.guid;
    delete newLogo.data.thumbnail;
    newLogo.data.direction = 0;

    adjustLogoOriginSizeByLimitation(newLogo.data, studioItemType, draggingArea);
    newLogo.data.x = Math.round((draggingArea.width - newLogo.data.width) / 2 + draggingArea.x);
    newLogo.data.y = Math.round((draggingArea.height - newLogo.data.height) / 2 + draggingArea.y);
    offsetNewRecentArtOrText(newLogo, canvasData.imageList);

    dispatch(unSelectAllImage);

    dispatch(
      addNewElement((elementId, layerIndex) => {
        dispatch(
          applyArt({
            canvasKey,
            newArt: newLogo,
            elementId,
            layerIndex,
          })
        );
      }, newLogo.data)
    );

    if (getScreenMode() === nextgenScreenMode.small) {
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
    }

    const guid = newLogo.ui.guid;
    if (!hasLatestLogo) {
      const colorizeParams = {
        dispatch,
        vendorId: getVendorId(state),
        imprintColorList: getImprintColors(state),
        hasOneImprintColorOnly: getHasOneImprintColorOnly(state),
        isHotStamped: getCurrentHotStampedCheck(state),
        itemUseScene7Template: true,
        processType: getCurrentImprintProcessType(state),
        isNextgenUi: true,
        currentImprintFormat: getCurrentImprintFormat(state),
        imprintOptionType: getImprintOptionType(state, canvasKey),
        allColorsInUse: getAllColorsInUse(state),
        isMultipleArtMultipleColor: getIsMultipleArtMultipleColor(state),
        logoEditingStatus: getLogoEditingStatus(state),
        studioItemType,
        draggingArea,
        canvasKey,
      };
      if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
        autoColorizeForUploadLogo({
          colorizeParams,
          updatedImageData: newLogo.data,
          guid,
          callbackAfterColorize: (colorizedImageData) => {
            //save new logo'colors to the origin color list
            dispatch(saveImageOriginColors({ canvasKey, imageId: guid }));

            confirmAutoColorize(dispatch, colorizeParams, colorizedImageData, guid);
            dispatch(pushToUndoList(undoRedoType.UploadLogo));
            dispatch(updateFullPreview());
          },
        });
      } else if (studioItemType === studioItemTypeEnum.digital) {
        if (!checkAndSharpen(dispatch, colorizeParams, newLogo.data, guid)) {
          hideCover(dispatch);
          dispatch(pushToUndoList(undoRedoType.UploadLogo));
          dispatch(updateFullPreview());
        }
      }
    } else {
      hideCover(dispatch);
      dispatch(pushToUndoList(undoRedoType.UploadLogo));
      dispatch(updateFullPreview());
    }
  };

export const setSavedArtList = (processType, imprintAreaCode) => (dispatch) => {
  getSavedArtListApi(processType, imprintAreaCode).then((response) => {
    dispatch(
      savedArtsListInit({
        processType,
        imprintAreaCode,
        list: response.data,
      })
    );
  });
};

export const updateTextColorByLogoColor =
  ({ formatkey, newColor, oldColor }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentStudioItemType = getStudioItemType(state);
    const textList = state.textDict[formatkey];
    if (textList !== undefined && textList !== null) {
      let increment = {};
      increment.data = {
        color: {
          cmyk: '',
          colorReference: newColor.colorReference,
          colorType: newColor.colorType,
          colorId: newColor.colorId,
          colorDescription: newColor.colorDescription,
        },
      };
      if (textList.length > 0) {
        if (currentStudioItemType === studioItemType.screenPrintedDigital && newColor.colorReference) {
          textList.forEach((element) => {
            if (element.data.color.colorId === oldColor.colorId) {
              dispatch(
                changeColor(
                  element.ui.guid,
                  newColor.cmyk,
                  newColor.colorId,
                  newColor.colorReference,
                  newColor.colorType,
                  newColor.colorDescription
                )
              );
            }
          });
        }
      }
    }
  };

export const updateImageColorByLogoColor = (params) => (dispatch, getState) => {
  const { formatkey, newColor, oldColor, selectedLogo } = params;
  const state = getState();
  if (state.imageDict && state.imageDict[formatkey]) {
    const artList = state.imageDict[formatkey].filter(
      (x) =>
        x.data.type === userImageType.StockArt ||
        x.data.type === userImageType.UploadLogo ||
        x.data.type === userImageType.SavedArt
    );
    artList.forEach((userimg) => {
      const needChangeColor =
        userimg.ui.guid !== selectedLogo.ui.guid &&
        userimg.data &&
        userimg.data.colors.find((color) => color.colorId === oldColor.colorId);
      if (needChangeColor) {
        if (userimg.data.type === userImageType.UploadLogo || userimg.data.type === userImageType.SavedArt) {
          changeLogoColor({ ...params, selectedLogo: userimg, newColor, isChangingColor: true });
        } else if (userimg.data.type === userImageType.StockArt) {
          dispatch(changeArtColor({ canvasKey: formatkey, guid: userimg.ui.guid, colors: [newColor], oldColor }));
        }
      }
    });
  }
};

export const updateImageColorByTextColor = (params) => (dispatch, getState) => {
  const { formatkey, newColor, oldColor } = params;
  const state = getState();
  if (state.imageDict && state.imageDict[formatkey]) {
    const artList = state.imageDict[formatkey].filter(
      (x) =>
        x.data.type === userImageType.StockArt ||
        x.data.type === userImageType.UploadLogo ||
        x.data.type === userImageType.SavedArt
    );
    artList.forEach((userimg) => {
      const needChangeColor = userimg.data && userimg.data.colors.find((color) => color.colorId === oldColor.colorId);
      if (needChangeColor) {
        if (userimg.data.type === userImageType.UploadLogo || userimg.data.type === userImageType.SavedArt) {
          changeLogoColor({ ...params, selectedLogo: userimg, newColor, isChangingColor: true });
        } else if (userimg.data.type === userImageType.StockArt) {
          dispatch(changeArtColor({ canvasKey: formatkey, guid: userimg.ui.guid, colors: [newColor], oldColor }));
        }
      }
    });
  }
};

export const resetImageToOriginal = (imageData) => {
  imageData.cropRect = {
    x: 0,
    y: 0,
    width: imageData.autoCropRect.width,
    height: imageData.autoCropRect.height,
  };
  if (imageData.autoCropRect.width > 0 && imageData.autoCropRect.height > 0) {
    Object.assign(imageData.finalCropRect, imageData.autoCropRect);
  } else {
    imageData.finalCropRect.x = 0;
    imageData.finalCropRect.y = 0;
    imageData.finalCropRect.width = imageData.originalWidth;
    imageData.finalCropRect.height = imageData.originalHeight;
  }
  imageData.width = Math.round(imageData.finalCropRect.width);
  imageData.height = Math.round(imageData.finalCropRect.height);
  imageData.direction = 0;
  imageData.removeWhiteOption = removeWhiteMode.None;
  imageData.colors = [];
  imageData.flipType = flipTypes.None;
  imageData.pngFileName = imageData.pngFileNameOfNoColorize || imageData.pngFileName;
};
